var controlBar = {
    bindings : {},
    /**
     * @ngInject
     */
    controller : function ControlBarCtrl ($scope, $auth, $mdDialog, flux, userStore, Tracking) {
        
        var ctrl = this;
        ctrl.isAuthenticated = false;

        function init () {

        }

        function link () {
        }

        ctrl.showJobMapPopup = function help(ev) {
            $mdDialog.show({
                controller: showJobMapDialogCtrl,
                controllerAs: '$ctrl',
                templateUrl: './angular/views/job-map-dialog.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: false
            });
        };

        ctrl.help = function help(ev) {
            $mdDialog.show({
                controller: HelpDialogCtrl,
                controllerAs: '$ctrl',
                templateUrl: './angular/views/help-dialog.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: false
            });
            Tracking.trackEvent("footer","hjaelp","");
        };

        ctrl.seeApplication = function seeApplication(ev) {
            if($auth.isAuthenticated()) {
                var win = window.open('/min-ansoegning?token=' + $auth.getToken(), '_blank');
                win.focus();
                Tracking.trackEvent("footer","se ansoegning","");
            } else {
                ctrl.login(ev);
            }
        };

        ctrl.login = function login(ev) {
            $mdDialog.show({
                controller: DialogCtrl,
                controllerAs: '$ctrl',
                templateUrl: './angular/views/dialog.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                fullscreen: false,
                locals: {
                    state: 'create',
                    successBtnState: 'see-application'
                }
            });
        };

        function authCallback(response){
            ctrl.isAuthenticated = $auth.isAuthenticated();
        }

        ctrl.$onInit = init;
        ctrl.$postLink = link;
        $scope.$listenTo(userStore, ['authenticated'], authCallback);
    },
    templateUrl : './angular/components/control-bar.component.html'
};